<template>
   <div  :class="info.is_read === 1 ? 'colorBlue' : ''" class="box-item"  >
    <div class="item-message">
      <!-- 0未读，1已读 -->
      <p class="p-isRead" v-show="info.is_read === 0"></p>
      <p
        style="cursor: pointer"
        v-html="info.message"
        @click="clickButton(info.id)"
      ></p>
    </div>
    <div class="item-time">
      <p>
        <!-- {{ dayjs(info.create_time * 1000).format("YYYY-MM-DD") }} -->
        {{ info.create_time }}
      </p>

      <p @click="clickButton(info.id)">
        <span>查看详情</span>
        <el-icon><ArrowRight /></el-icon>
      </p>
    </div>
  </div>
</template>

<script setup>
import { ArrowRight } from "@element-plus/icons-vue";
import { reactive } from "vue";
import { useRouter,useRoute } from "vue-router";
import dayjs from "dayjs";

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  path: "",
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
});

const props = defineProps({
  path: {
    type: String,
    // default: "",
  },
  info: {
    type: Object,
    default: () => {
      return {};
    },
  },
});

//按钮点击事件
function clickButton(id) {
  router.push({
    path: "/layout/list/notificationsDetails",
    query: { id },
  });
}
</script>


<style scoped lang="scss">
.box-item {
  width: 311px !important;
  // height: 60px;
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  padding: 10px;
  // margin-bottom: 20px;
  // border: 1px solid #346de0;
  background-color:#f2f2f2 ;
  box-shadow: 0px 5px 40px 0px #0000000d;
  border-radius: 8px;
  border-radius: 8px;
  position: relative;
  .item-message {
    width: 100%;
    // border: 1px solid rgb(0, 255, 85);
    line-height: 20px;
    // display: flex;
    // align-items: center;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    padding-bottom: 6px;
    // border-bottom: 1px solid #f2f2f2;
    
    > p:nth-of-type(2){
      display:block;
      // overflow: hidden;
      // white-space: nowrap; //不折行
      // text-overflow: ellipsis; //文本溢出 用省略号显示
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
      text-overflow: ellipsis; //文本溢出 用省略号显示
      -webkit-line-clamp: 2;//几行
      
    }
    // > p:nth-of-type(2) {
    //   width: 8px;
    //   height: 8px;
    //   border-radius: 4px;
    //   background-color: #ff0000;
    //   margin-left:5px;
    // }
  }

  .item-time {
    font-size: 12px;
    margin-top: 6px;
    color: #666666;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > p:nth-of-type(2) {
      display: flex;
      align-items: center;
      cursor: pointer;
      :deep(.el-icon) {
        margin-left: 2px;
        margin-top: 1px;
      }
    }
  }
}
// .box-item:nth-last-of-type(1) {
//   margin-bottom: 0px;
// }

.box-item:hover {
  p {
    color: #009de0;
  }
}

//是否已读（已读——没有红点；未读——有红点）
.p-isRead {
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: #ff0000;
  // margin-left: 5px;

  position: absolute;
  left: 5px;
  top: 5px;
}


.colorBlue{
   
  background-color: #f2f2f2ac ;
  // background-color: red;
  .item-message{
    >p:nth-of-type(2){
      color:#333333b7
    }
  }
}
</style>